import {
  RESET_DYNAMIC_LIST,
  RESET_DYNAMIC_LIST_ITEM,
  SET_DYNAMIC_LIST,
  SET_DYNAMIC_LIST_ITEM,
  FETCH_DYNAMIC_LIST_INIT,
  FETCH_DYNAMIC_LIST_ALL_INIT,
  FETCH_DYNAMIC_ITEM_ALL_INIT,
  FETCH_DYNAMIC_LIST_ALL_SUCCESS,
  FETCH_DYNAMIC_ITEM_ALL_SUCCESS,
  FETCH_DYNAMIC_LIST_ALL_FAILURE,
  FETCH_DYNAMIC_ITEM_ALL_FAILURE,
  FETCH_DYNAMIC_LIST_DELETE_INIT,
  FETCH_DYNAMIC_LIST_INIT_ITEM,
  FETCH_DYNAMIC_LIST_SUCCESS,
  FETCH_DYNAMIC_LIST_DELETE_SUCCESS,
  FETCH_DYNAMIC_LIST_SUCCESS_ITEM,
  FETCH_DYNAMIC_LIST_FAILURE,
  FETCH_DYNAMIC_LIST_DELETE_FAILURE,
  FETCH_DYNAMIC_LIST_FAILURE_ITEM,
  FETCH_LIST_CONCAT,
  DELETE_LIST_FROM_STORE,
  RESET_ITEMS,
  CONCAT_ITEMS,
  EDIT_ITEM_INIT,
  EDIT_ITEM_FAILURE,
  EDIT_ITEM_SUCCESS,
  EDIT_ITEMS_INIT,
  EDIT_ITEMS_FAILURE,
  EDIT_ITEMS_SUCCES,
  DELETE_ITEM_INIT,
  DELETE_ITEM_FAILURE,
  DELETE_ITEM_SUCCES,
  DELETE_ITEM,
  DELETE_ITEM_ONCE
} from './types';
import API from './api';

/* Actions Creators */

export function setDynamiList(obj) {
  return {
    type: SET_DYNAMIC_LIST,
    payload: obj
  };
}

export function resetDynamicList() {
  return {
    type: RESET_DYNAMIC_LIST
  };
}

function fetchApiSuccess(data) {
  return {
    type: FETCH_DYNAMIC_LIST_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_DYNAMIC_LIST_FAILURE,
    payload: error
  };
}

function fetchApiSuccessListDelete(data) {
  return {
    type: FETCH_DYNAMIC_LIST_DELETE_SUCCESS,
    payload: data
  };
}

function fetchApiInitDeleteList() {
  return {
    type: FETCH_DYNAMIC_LIST_DELETE_INIT
  };
}

function fetchApiFailureDeleteList(error) {
  return {
    type: FETCH_DYNAMIC_LIST_DELETE_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_DYNAMIC_LIST_INIT
  };
}

export function createList(list) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.handleList(list);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

function deletListFromStore(list) {
  return {
    type: DELETE_LIST_FROM_STORE,
    payload: list
  };
}

export function deleteList(list) {
  return async dispatch => {
    dispatch(fetchApiInitDeleteList());
    try {
      let data = await API.data.handleDeleteList(list);
      dispatch(fetchApiSuccessListDelete(data));
      dispatch(deletListFromStore(list));
    } catch (error) {
      dispatch(fetchApiFailureDeleteList(error));
    }
  };
}

/* Item */

export function setDynamiListItem(obj) {
  return {
    type: SET_DYNAMIC_LIST_ITEM,
    payload: obj
  };
}

export function resetDynamicListItem() {
  return {
    type: RESET_DYNAMIC_LIST_ITEM
  };
}

function fetchApiInitItem() {
  return {
    type: FETCH_DYNAMIC_LIST_INIT_ITEM
  };
}

function fetchApiSuccessItem(data) {
  return {
    type: FETCH_DYNAMIC_LIST_SUCCESS_ITEM,
    payload: data
  };
}

function fetchApiFailureItem(error) {
  return {
    type: FETCH_DYNAMIC_LIST_FAILURE_ITEM,
    payload: error
  };
}

export function createItem(item) {
  return async dispatch => {
    dispatch(fetchApiInitItem());
    try {
      let data = await API.data.handleItem(item);
      dispatch(fetchApiSuccessItem(data));
    } catch (error) {
      dispatch(fetchApiFailureItem(error));
    }
  };
}

// Fetch all list from the API
function fetchAllListInit() {
  return {
    type: FETCH_DYNAMIC_LIST_ALL_INIT
  };
}

function fetchAllListSuccess(data) {
  return {
    type: FETCH_DYNAMIC_LIST_ALL_SUCCESS,
    payload: data
  };
}

function fetchAllListFailure(error) {
  return {
    type: FETCH_DYNAMIC_LIST_ALL_FAILURE,
    payload: error
  };
}

export function getAllList(obj) {
  return async dispatch => {
    dispatch(fetchAllListInit());
    try {
      let data = await API.data.handleAllList(obj);
      dispatch(fetchAllListSuccess(data));
    } catch (error) {
      dispatch(fetchAllListFailure(error));
    }
  };
}

export function getAllListWithItems(obj) {
  return async dispatch => {
    dispatch(fetchAllListInit());
    try {
      let data = await API.data.handleAllListWithItems(obj);
      dispatch(fetchAllListSuccess(data));
    } catch (error) {
      dispatch(fetchAllListFailure(error));
    }
  };
}

function conCat() {
  return {
    type: FETCH_LIST_CONCAT
  };
}

export function doConcat() {
  return dispatch => {
    dispatch(conCat());
  };
}

// Get items by list
function fetchItemByListInit(list?) {
  return {
    type: FETCH_DYNAMIC_ITEM_ALL_INIT,
    list
  };
}

function fetchItemByListSucces(data, list?) {
  return {
    type: FETCH_DYNAMIC_ITEM_ALL_SUCCESS,
    payload: data,
    list
  };
}

function fetchItemByListFailure(error) {
  return {
    type: FETCH_DYNAMIC_ITEM_ALL_FAILURE,
    payload: error
  };
}

export function getAllItemByList(obj, list?) {
  // let getList;
  // if (list) {
  //   getList = list;
  // }
  return async dispatch => {
    if (list) {
      dispatch(fetchItemByListInit(list));
    } else {
      dispatch(fetchItemByListInit());
    }

    try {
      if (list) {
        let data = await API.data.handleItemByList(obj);
        dispatch(fetchItemByListSucces(data, list));
      } else {
        let data = await API.data.handleItemByList(obj);
        dispatch(fetchItemByListSucces(data));
      }
    } catch (error) {
      dispatch(fetchItemByListFailure(error));
    }
  };
}

export function handleResetItems() {
  return dispatch => {
    return dispatch({
      type: RESET_ITEMS
    });
  };
}

export function concatItems(item) {
  return dispatch => {
    return dispatch({
      type: CONCAT_ITEMS,
      payload: item
    });
  };
}

function handleEditItemInit(index) {
  return {
    type: EDIT_ITEM_INIT
  };
}

function handleEditItemFailure(error) {
  return {
    type: EDIT_ITEM_FAILURE,
    payload: error
  };
}

function handleEditItemSucces(data) {
  return {
    type: EDIT_ITEM_SUCCESS,
    payload: data
  };
}

function handleEditItemsInit() {
  return {
    type: EDIT_ITEMS_INIT
  };
}

function handleEditItemsFailure(error) {
  return {
    type: EDIT_ITEMS_FAILURE,
    payload: error
  };
}

function handleEditItemsSucces(data) {
  return {
    type: EDIT_ITEMS_SUCCES,
    payload: data
  };
}

export function handleEditItem(obj, index) {
  return async dispatch => {
    dispatch(handleEditItemInit(index));
    try {
      //let data = await API.data.handleEditItem(obj);
      dispatch(handleEditItemSucces({ obj, index }));
    } catch (error) {
      dispatch(handleEditItemFailure(error));
    }
  };
}

export function handleEditItemstest(obj) {
  return async dispatch => {
    dispatch(handleEditItemsInit());
    try {
      let data = await API.data.handleEditItem(obj);
      dispatch(handleEditItemsSucces({ data, obj }));
    } catch (error) {
      dispatch(handleEditItemsFailure(error));
    }
  };
}

function handleDeleteItemInit() {
  return {
    type: DELETE_ITEM_INIT
  };
}

function handleDeleteItemFailure(error) {
  return {
    type: DELETE_ITEM_FAILURE,
    payload: error
  };
}

function handleDeleteItemSucces(data) {
  return {
    type: DELETE_ITEM_SUCCES,
    payload: data
  };
}

export function handleDeleteItems(obj) {
  return async dispatch => {
    dispatch(handleDeleteItemInit());
    try {
      let data = await API.data.handleDeleteItem(obj);
      dispatch(handleDeleteItemSucces({ data, obj }));
    } catch (error) {
      dispatch(handleDeleteItemFailure(error));
    }
  };
}

function deleteItem(data) {
  return {
    type: DELETE_ITEM_ONCE,
    payload: data
  };
}
export function handleDeleteItem(obj, index) {
  return async dispatch => {
    try {
      await dispatch(deleteItem({ obj, index }));
    } catch (error) {}
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/dynamic_list/index.js